'use strict';

import ngResource from 'angular-resource';

function DemandPowerService ($resource) {
    return $resource(
        '/api/demand_power/:id',
        { id: '@id' },
        { show: { method: 'GET', isArray: false } }
    )
}

export default angular.module('leptonApp.DemandPowerService', ['ngResource'])
    .factory('DemandPowerService', ['$resource', DemandPowerService])
    .name;



// WEBPACK FOOTER //
// ./public/dev/components/api/demand_power/demand_power.service.js